import { css } from "styled-components";

export const datepickerWrapperStyles = () => {
    return css`
        > div { /* Targets the non customizable wrapper of the DatePicker Component */
            width: 100%;
        }
    `;
};
